import React from 'react'
import { useTranslation } from 'lib/i18n'

import NotFoundPage from 'components/NotFound/NotFoundPage'

const ProfileCollectionNotFoundPage = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <NotFoundPage
      title={t(
        'profileCollection.slug.404.title',
        'Profile Collection not found',
      )}
      subTitle={t(
        'profileCollection.slug.404.subTitle',
        'Sorry, the profile collection you were looking for does not exist.',
      )}
      backButtonText={t(
        'profileCollection.slug.404.goBack',
        'Check out our other profile collections',
      )}
      backButtonHref="/"
    />
  )
}

export default ProfileCollectionNotFoundPage
